import * as React from "react";
import { render } from "react-dom";
import { Information } from "./components/contact/Information";

render(
    <Information></Information>,
    document.querySelector(".information")
  );